module.exports = __webpack_public_path__ + "static/img/p1_06.60ead1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutOur/intro/p1_06.jpg
// module id = r4P9
// module chunks = 0